import React, { useState } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import Input from '../../../../components/form-control/Input';
import Button from '../../../../components/form-control/Button';
import SelectDropdown from '../../../../components/form-control/SelectDropdown';
import { useSelector } from 'react-redux';
import { getEnumsFromState } from '../../../../states/slices/resourceSlice';
import { IEnum } from '../../../../resources/interfaces';
import { useQuery } from '@tanstack/react-query';
import { getAllRiskTypes, getlNoClaimDiscountById, getRiskCategoriesEnums, getVehicleUsesEnums } from '../../../../api/requests';
import { useSearchParams } from 'react-router-dom';

interface IProps {
  onClose?: () => void;
  onConfirm?: (values:IDiscountRate) => void;
  type?: any;
  riskTypes: any[];
}

export interface IDiscountRate {
  active: boolean;
  age?: number;
  discount?: number;
  riskTypeId?: number;
  title: string;
  vehicleUse: string;
}


const AddDiscountRateModal = ({ onClose, onConfirm, type }: IProps) => {
  const enumsList = useSelector(getEnumsFromState);
  const [selectedUsage, setSelectedUsage] = useState({})


 const [riskTypes, setRiskTypes] = useState([])
 // const riskTypesName = riskTypes.filter((type:any) => type.riskCategory.key === )
  
  const initialValues: IDiscountRate = {
    active: type ? type.active : true,
    age: type ? type.age : undefined,
    discount: type ? type.discount : undefined,
    riskTypeId: type ? type.riskCategory?.key : undefined,
    title: type ? type?.title : '',
    vehicleUse: type ? type.vehicleUse?.key : ''
  };

 
    const [vehicleUse, setVehicleUse] = useState<IEnum[]>([])
  
      const getRiskTypes = async () => {
       await getAllRiskTypes()
        .then((response:any) => {
          setRiskTypes(response)
        })
        .catch((error: Error) => {
          console.log("error",error)
        })
        .finally(() => {})
      };
   
     const vehicleUseEnumlist = async () => {
      await getVehicleUsesEnums()
      .then((response:any) => {
        setVehicleUse(response)
      })
    }
  
   useQuery({queryKey:['getRiskTypes'], queryFn: getRiskTypes})
    useQuery({queryKey:['vehicleUseEnumlist'], queryFn: vehicleUseEnumlist})
    
  return (
    <div className="py-6 px-3 md:px-6  w-full">
      <Formik
        initialValues={initialValues}
        enableReinitialize={true}
        validateOnChange={true}
        validateOnBlur={true}
        validationSchema={Yup.object().shape({


          age: Yup.number()
            .typeError('Age must be a number')
            .required('Age is required.'),

          discount: Yup.number()
            .typeError('Discount must be a number')
            .required('Discount is required.'),

          // riskTypeId: Yup.number()
          //   .required('Risk Type  is required.'),

          title: Yup.string()
            .required('Title is required.'),

          vehicleUse: Yup.string()
            .required('Vehicle Use is required.')
        })}
        onSubmit={async (values: IDiscountRate, { resetForm }) => {
          const payload: IDiscountRate = {
            active: false,
            age: values.age,
            discount: values.discount,
            riskTypeId: values.riskTypeId,
            title: values.title,
            vehicleUse: values.vehicleUse
          }
          onConfirm?.(payload);
        }}>
        {({
          values,
          errors,
          isSubmitting,
          handleSubmit,
          handleChange,
          handleBlur,
          setFieldValue,
          touched
        }) => (
          <form className="" onSubmit={handleSubmit}>
            <div className="w-full flex flex-col space-y-8">
               <Input
                type={'text'}
                name="title"
                value={values.title}
                onChange={handleChange}
                onBlur={handleBlur}
                label="Title"
                placeholder="Enter title"
                required
                error={touched.title ? errors.title : undefined}
                helperText={touched?.title ? errors.title : undefined}
                className="rounded"
              />

              <Input
                type={'text'}
                name="age"
                value={values.age}
                onChange={handleChange}
                onBlur={handleBlur}
                label="Age"
                placeholder="Enter age"
                required
                error={touched.age ? errors.age : undefined}
                helperText={touched?.age ? errors.age : undefined}
                className="rounded"
              />

              <Input
                type={'number'}
                name="discount"
                value={values.discount}
                onChange={handleChange}
                onBlur={handleBlur}
                label="Discount"
                placeholder="Enter discount"
                required
                error={touched.discount ? errors.discount : undefined}
                helperText={touched?.discount ? errors.discount : undefined}
                className="rounded"
              />

              <SelectDropdown
                name="riskTypeId"
                listSelectedValue={values.riskTypeId}
                onChange={(value: string) => {
                  setFieldValue('riskTypeId', value);
                }}
                label="Risk Category"
                placeholder="Select risk"
                list={riskTypes?.map((riskType: any) => ({
                  name: `${riskType.name}`,
                  value: `${riskType.id}`
                }))}
                error={touched.riskTypeId ? errors.riskTypeId : undefined}
                helperText={touched?.riskTypeId ? errors.riskTypeId : undefined}
                selectInputClassName="rounded"
              />

              <SelectDropdown
                name="vehicleUse"
                listSelectedValue={values.vehicleUse}
                onChange={(value: string) => {
                  setFieldValue('vehicleUse', value);
                  value && setSelectedUsage(value)
                }}
                label="Vehicle usage"
                placeholder="Select vehicle usage"
                list={vehicleUse?.map((vehicle: IEnum) => ({
                  name: `${vehicle.title}`,
                  value: `${vehicle.key}`,
                }))}
                required
                 error={touched.vehicleUse ? errors.vehicleUse : undefined}
                helperText={touched?.vehicleUse ? errors.vehicleUse : undefined}
                selectInputClassName="rounded"
              />

              <div className="w-full flex gap-4 mt-6 !mb-4">
                <Button
                  type="button"
                  label="Cancel"
                  onClick={onClose}
                  bgColor='secondary'
                  fullWidth
                />
                <Button
                  label="Submit"
                  type='submit'
                  bgColor='primary'
              fullWidth
                  //   loading={submitting}
                  //   disabled={submitting}
                />
              </div>
            </div>
          </form>
        )}
      </Formik>
    </div>
  );
};

export default AddDiscountRateModal;
